import { areDisplayAdsEnabled } from 'owa-mail-ads-checker';
import BrowserWidthBucket from '../store/schema/BrowserWidthBucket';
import { getBrowserWidth } from 'owa-config';

/**
 * Gets the available width bucket
 */
export default function getAvailableWidthBucket(skipCache?: boolean): BrowserWidthBucket {
    let availableWidth = getBrowserWidth(skipCache);

    /**
     * Subtract the ads panel width to get the available width
     * to layout the app's main content
     */
    if (areDisplayAdsEnabled()) {
        if (availableWidth > 1900) {
            availableWidth = availableWidth - 305;
        } else if (availableWidth > 990) {
            availableWidth = availableWidth - 165;
        }
    }

    if (availableWidth >= 1600) {
        return BrowserWidthBucket.From1600_Above;
    }

    if (availableWidth >= 1400) {
        return BrowserWidthBucket.From1400_To1599;
    }

    if (availableWidth >= 1200) {
        return BrowserWidthBucket.From1200_To1399;
    }

    if (availableWidth >= 1000) {
        return BrowserWidthBucket.From1000_To1199;
    }

    if (availableWidth >= 919) {
        return BrowserWidthBucket.From919_To999;
    }

    if (availableWidth >= 769) {
        return BrowserWidthBucket.From769_To918;
    }

    if (availableWidth >= 555) {
        return BrowserWidthBucket.From555_To768;
    }

    if (availableWidth >= 419) {
        return BrowserWidthBucket.From419_To554;
    }

    return BrowserWidthBucket.From418_Below;
}
